<template>
  <div class="af-backdrop">
    <div class="af-modal">
      <!-- Header -->
      <div class="af-header">
        <h5 class="af-title">Panel de filtros</h5>
      </div>

      <!-- Body -->
      <div class="af-body">
        <div class="af-section" v-if="showSearch">
          <div class="af-section-title">Búsqueda</div>

          <div class="af-general-item af-search-item">
            <label class="af-label">Buscar por UUID, RFC o Razón Social</label>
            <input
              class="form-control form-control-sm"
              type="text"
              v-model="localSearch"
              placeholder="UUID, RFC o Razón Social"
            />
          </div>
        </div>

        <div class="af-section" v-if="showStatus || showMethod || showPeriod">
          <div class="af-section-title">Filtros generales</div>

          <div class="af-general-grid">
            <div class="af-general-item" v-if="showPeriod">
              <label class="af-label">Periodo</label>
              <YearMonthSelect :period="localPeriod" @change="changePeriod" />
            </div>

            <div class="af-general-item" v-if="showStatus">
              <label class="af-label">Estado</label>
              <div class="btn-group af-chip-group" role="group">
                <button type="button" class="btn btn-sm" :class="localStatus === '1' ? 'btn-primary' : 'btn-light'" @click="localStatus = '1'">Vigentes</button>
                <button type="button" class="btn btn-sm" :class="localStatus === '0' ? 'btn-primary' : 'btn-light'" @click="localStatus = '0'">Cancelados</button>
                <button type="button" class="btn btn-sm" :class="localStatus === 'ALL' ? 'btn-primary' : 'btn-light'" @click="localStatus = 'ALL'">Todos</button>
              </div>
            </div>

            <div class="af-general-item" v-if="showMethod">
              <label class="af-label">Método de pago</label>
              <div class="btn-group af-chip-group" role="group">
                <button type="button" class="btn btn-sm" :class="localMethod === 'PUE' ? 'btn-primary' : 'btn-light'" @click="localMethod = 'PUE'">PUE</button>
                <button type="button" class="btn btn-sm" :class="localMethod === 'PPD' ? 'btn-primary' : 'btn-light'" @click="localMethod = 'PPD'">PPD</button>
                <button type="button" class="btn btn-sm" :class="localMethod === 'ALL' ? 'btn-primary' : 'btn-light'" @click="localMethod = 'ALL'">Todos</button>
              </div>
            </div>

            <div class="af-general-item" v-if="showPersonalDeductions">
              <label class="af-label">Deducciones personales</label>
              <div class="btn-group af-chip-group" role="group">
                <button type="button" class="btn btn-sm" :class="localPersonalDeductions ? 'btn-primary' : 'btn-light'" @click="localPersonalDeductions = true">Solo deducciones</button>
                <button type="button" class="btn btn-sm" :class="!localPersonalDeductions ? 'btn-primary' : 'btn-light'" @click="localPersonalDeductions = false">Todos</button>
              </div>
            </div>
          </div>
        </div>

        <div class="af-section" v-if="showAdvanced">
          <div class="af-section-title">Filtros personalizados</div>

        <div v-for="(f, idx) in localFilters" :key="idx" class="af-row">
          <!-- Campo -->
          <select class="form-select form-select-sm af-field" v-model="f.field" @change="onFieldChange(f)">
            <option value="" disabled>Selecciona campo</option>
            <option v-for="opt in fields" :key="opt.code" :value="opt.code">
              {{ opt.name }}
            </option>
          </select>

          <!-- Operador -->
          <select class="form-select form-select-sm af-op" v-model="f.op">
            <option v-for="op in opsForField(f.field)" :key="op" :value="op">{{ op }}</option>
          </select>

          <!-- Valor -->
            <template v-if="fieldMeta(f.field).type === 'select'">
            <select class="form-select form-select-sm af-value" v-model="f.value">
                <option value="" disabled>Selecciona</option>
                <option v-for="v in fieldMeta(f.field).values" :key="v.value" :value="v.value">
                {{ v.label }}
                </option>
            </select>
            </template>

            <!-- DATE -->
            <template v-else-if="fieldMeta(f.field).type === 'fecha' || fieldMeta(f.field).type === 'date'">
            <!-- between: dos fechas -->
            <div v-if="f.op === 'entre'" class="af-between">
                <input
                class="form-control form-control-sm"
                type="date"
                v-model="f.value.from"
                placeholder="Desde"
                />
                <input
                class="form-control form-control-sm"
                type="date"
                v-model="f.value.to"
                placeholder="Hasta"
                />
            </div>

            <!-- operadores normales: una fecha -->
            <input
                v-else
                class="form-control form-control-sm af-value"
                type="date"
                v-model="f.value"
            />
            </template>

            <!-- TEXT / NUMBER (default) -->
            <template v-else>
            <input
                class="form-control form-control-sm af-value"
                :type="fieldMeta(f.field).type === 'number' ? 'number' : 'text'"
                v-model="f.value"
                :placeholder="fieldMeta(f.field).placeholder || 'Valor'"
            />
            </template>

          <!-- Remove -->
          <button class="btn btn-link af-remove" type="button" @click="removeFilter(idx)">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <button class="btn btn-link af-add" type="button" @click="addFilter">
          <i class="fa fa-plus"></i> Agregar filtro
        </button>
        </div>
      </div>

      <!-- Footer -->
      <div class="af-footer">
        <button type="button" class="btn btn-outline-primary" @click="$emit('close')">
          Cancelar
        </button>
        <button type="button" class="btn btn-primary" @click="apply">
          Aplicar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_OPS = ["=", "!=", "contiene", "inicia", "termina", ">=", "<=", ">", "<"];

import ws from "@/services/cfdis";
import YearMonthSelect from "@/components/cfdis/YearMonthSelect.vue";

export default {
  name: "CfdiAdvancedFilterModal",
  components: { YearMonthSelect },
  props: {
    nature: { type: String, default: "" },
    group: { type: String, default: "" },
    filters: { type: Array, default: () => [] },
    search: { type: String, default: "" },
    status: { type: String, default: "ALL" },
    method: { type: String, default: "ALL" },
    period: { type: String, default: "" },
    showSearch: { type: Boolean, default: true },
    showStatus: { type: Boolean, default: true },
    showMethod: { type: Boolean, default: true },
    showPeriod: { type: Boolean, default: true },
    showAdvanced: { type: Boolean, default: true },
    showPersonalDeductions: { type: Boolean, default: false },
    personalDeductions: { type: Boolean, default: false },
  },
  data() {
    return {
      fields: [],
      localFilters: [],
      localSearch: "",
      localStatus: "ALL",
      localMethod: "ALL",
      localPeriod: "",
      localPersonalDeductions: false,
    };
  },
  created() {
    this.localFilters = (this.filters || []).map(f => ({ ...f }));
    this.localSearch = this.search || "";
    this.localStatus = this.status || "ALL";
    this.localMethod = this.method || "ALL";
    this.localPeriod = this.period || "";
    this.localPersonalDeductions = !!this.personalDeductions;

    if (this.showAdvanced && this.localFilters.length === 0) this.addFilter();
  },
  async mounted() {
    if (this.showAdvanced && this.fields.length === 0) {
      const response = await ws.getFilters(this.nature, this.group);
      if (response && response.type === "success") {
        this.fields = response.data || [];
      }
    }
  },
  methods: {
    changePeriod(period) {
      this.localPeriod = period;
    },
    fieldMeta(fieldKey) {
      const found = this.fields.find(x => x.code === fieldKey);
      return found || { type: "text", operators: ["=", "contiene"], values: [] };
    },
    opsForField(fieldKey) {
      const meta = this.fieldMeta(fieldKey);
      return meta.operators && meta.operators.length ? meta.operators : DEFAULT_OPS;
    },
    onFieldChange(f) {
      const meta = this.fieldMeta(f.field);
      f.op = this.opsForField(f.field)[0] || "=";
      f.value = meta.type === "select" ? "" : "";
    },
    addFilter() {
      const firstField = this.fields[0]?.key || "";
      this.localFilters.push({
        field: firstField,
        op: this.opsForField(firstField)[0] || "=",
        value: "",
      });
    },
    removeFilter(idx) {
      this.localFilters.splice(idx, 1);
      if (this.showAdvanced && this.localFilters.length === 0) this.addFilter();
    },
    apply() {
      // Limpieza: solo enviar filtros con field + op (value puede ir vacío si así lo permites)
      const cleaned = this.localFilters
        .filter(f => f.field && f.op)
        .map(f => {
            const meta = this.fieldMeta(f.field);

            if (meta.type === "date" && f.op === "entre") {
                return {
                    field: f.field,
                    op: f.op,
                    value: {
                        from: f.value.from || null,
                        to: f.value.to || null,
                    },
                };
            }

            return { field: f.field, op: f.op, value: f.value };
        });

      this.$emit("apply", {
        search: this.localSearch,
        status: this.localStatus,
        method: this.localMethod,
        period: this.localPeriod,
        personal_deductions: this.localPersonalDeductions,
        advanced: cleaned,
      });
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.af-backdrop{
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.af-modal{
  background: #fff;
  border-radius: 10px;
  width: 720px;
  max-width: 95vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(15, 23, 42, 0.25);
}

.af-header{
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}
.af-title{ margin:0; font-size:16px; font-weight:600; }

.af-body{
  padding: 14px 20px 10px;
  overflow: auto;
}

.af-section {
  border: 1px solid var(--sidebar-border);
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  background: var(--white);
}

.af-section-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--theme-deafult);
  margin-bottom: 10px;
}

.af-general-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.af-general-item {
  min-width: 0;
}

.af-search-item {
  max-width: 100%;
}

.af-label {
  display: block;
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--theme-font-color);
  opacity: 0.8;
}

.af-chip-group .btn {
  border-color: var(--theme-deafult) !important;
}

.af-row{
  display: grid;
  grid-template-columns: 1fr 120px 1fr 34px;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
}

.af-remove{
  color: #6b7280;
  text-decoration: none;
  padding: 0;
}
.af-remove:hover{ color:#111827; }

.af-add{
  padding: 0;
  text-decoration: none;
  color: #111827;
  margin-top: 4px;
}

.af-footer{
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@media (max-width: 768px) {
  .af-general-grid {
    grid-template-columns: 1fr;
  }

  .af-row {
    grid-template-columns: 1fr;
  }
}
</style>
